import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './Components/Header'
import { routes } from './routes'
import PrivateRoute from './Components/PrivateRoute'

const Template = () => {
  return (
    <>
      <Header />

      <main id="content" className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <Routes>
          {Object.keys(routes).map((routeKey) => {
            const route = routes[routeKey]
            const Component = route.component
            const path = route.exact === false
              ? `${route.path.replace(/\/$/, '')}/*`
              : route.path

            const element = route.private ? (
              <PrivateRoute>
                <Component />
              </PrivateRoute>
            ) : (
              <Component />
            )

            return <Route key={routeKey} path={path} element={element} />
          })}
        </Routes>
      </main>

      <div className="footer-push" />
    </>
  )
}

export default Template
